document.addEventListener('DOMContentLoaded', () => {
  
  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1040,
    },
    toolFixedHorizontalScroll: {
      targetSelector: '.l-header',
    },
  })
  
  if (window.matchMedia('(max-width: 768px)').matches) {
  } else {
    const uwb = new UWB({
      toolSmoothScroll: {
        init: true,
        offsetSelector: '.l-header',
        reomveClasses: ['hide'],
      },
    })
  }
  
  UWX.ScrollActionReferPosition('.l-header', 100,{
    activeClass: '--fade'
  });
  UWX.ScrollActionReferPosition('.l-header', 500,{
    activeClass: '--fixed'
  });
  const startFire = document.documentElement.clientHeight;
  UWX.ScrollActionReferPosition('.l-header', startFire, {
    activeClass: '--reveal'
  });
  UWX.ScrollActionReferPosition('.c-h_nav-btn.--movie', 0, {
    activeClass: '--reveal',
    sedationLine: -1000,
  })

  UWX.Waiting('.js-rvl-main_img', {
    delayMSec: 300,
    activateClass: '--reveal',
  });
  UWX.Waiting('.js-rvl-main_title', {
    delayMSec: 900,
    activateClass: '--reveal',
  });
  UWX.Waiting('.js-rvl-header', {
    delayMSec: 1500,
    activateClass: '--reveal',
  });

  UWX.ScrollActionSelfElement('.js-rvl-cont', {
    rootMargin: '-25% 0%',
    activeClass: '--reveal',
    timing: 0,
    once: true,
    direction: 'both',
  });

  UWX.ScrollActionSelfElement('.js-rvl-custom', {
    rootMargin: '-25% 0%',
    activeClass: '--reveal',
    timing: 0,
    once: true,
    direction: 'both',
  });
})
